// extracted by mini-css-extract-plugin
export default {"primaryColorBase":"#096","primaryColorLight":"#04ae76","primaryColorLighter":"#13eca4","primaryColorLightest":"#5eedbe"};